import * as React from "react";
import * as main from "../../main.module.scss";
import * as res from "./style.module.scss";
export const ResultsAfter = ({ widgetFree, widgetPrice }) => {
  return (
    <section className={res.res}>
      <div className="container">
        <h2 className={main.title}>Результаты марафона</h2>
        <p className={main.subtitle}>После марафона вы узнаете:</p>
        <ul>
          <li>
            <a href="#resForm">
              <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/result-1.png" alt=""/>
              <p><strong>Ключевые ошибки в&nbsp;обучении</strong> которые совершает 90%&nbsp;родителей по&nbsp;незнанию</p>
            </a>
          </li>
          <li>
            <a href="#resForm">
              <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/result-2.png" alt=""/>
              <p>Как <strong>изменить подход к&nbsp;обучению без&nbsp;зубрежки</strong> и&nbsp;выполнения домашних заданий по&nbsp;ночам</p>
            </a>
          </li>
          <li>
            <a href="#resForm">
              <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/result-3.png" alt=""/>
              <p>Почему <strong>репетиторы не&nbsp;всегда полезны</strong> для&nbsp;обучения и&nbsp;нужны&nbsp;ли они вашим детям на&nbsp;самом деле</p>
            </a>
          </li>
          <li>
            <a href="#resForm">
              <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/result-4.png" alt=""/>
              <p><strong>Почему дети не&nbsp;хотят учиться</strong> и&nbsp;как школа и&nbsp;требования родителей развивают неуверенность в&nbsp;себе</p>
            </a>
          </li>
          <li>
            <a href="#resForm">
              <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/result-5.png" alt=""/>
              <p><strong>Что нужно дать ребенку в&nbsp;детстве</strong>, чтобы он&nbsp;смог сам обеспечить себе светлое успешное будущее</p>
            </a>
          </li>
          <li>
            <a href="#resForm">
              <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/result-6.png" alt=""/>
              <p><strong>Как наладить отношения с&nbsp;ребенком</strong> и&nbsp;как его следует правильно мотивировать </p>
            </a>
          </li>
        </ul>
        <div className={res.reg} id={"resForm"}>
          <div className={res.info}>
            <h3>Получите доступ к&nbsp;марафону</h3>
            <div className={res.priceWrap}>
              <p className={res.text}>Запишитесь сейчас и&nbsp;получите доступ к&nbsp;марафону бесплатно</p>
            </div>
          </div>
          <div className={res.form}>
            <h3>Заполните поля и мы отправим доступ на почту</h3>
            { widgetFree }
          </div>
        </div>
      </div>
    </section>
  );
};
